import { publicCardFacts } from '@bilt/domain/passportRegistry';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useSearchParams } from 'react-router-dom';
import { cardRequest, type PassportCard as Card } from '../../services/api/passportCards';
import PassportCard from './PassportCard';
export default function PassportCardExport() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const key = params.get('key') || '';
  const [card, setCard] = useState<Card | null>(null),
    [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setCard(null);
    setError('');
    void cardRequest<Card>('card', undefined, { key })
      .then((c) => {
        if (active) setCard(c);
      })
      .catch((e) => {
        if (active) setError(e.message);
      });
    return () => {
      active = false;
    };
  }, [key, user?.id]);
  return (
    <main className="pc-page pe-export-page">
      <header>
        <Link to="/passport">Back to Passport</Link>
        <h1>Export card</h1>
        <p>
          This static record includes both faces. It contains no scan or redemption credentials.
        </p>
        <button className="pc-button" disabled={!card} onClick={() => window.print()}>
          Print or save as PDF
        </button>
      </header>
      {error ? (
        <p role="alert">{error}</p>
      ) : !card ? (
        <p role="status">Loading your current permitted record…</p>
      ) : (
        <>
          <div className="pe-export-pair">
            <PassportCard card={card} staticOutput quiet reduceMotion />
            <PassportCard card={card} staticOutput quiet reduceMotion back readableStory />
          </div>
          <section className="pe-export-transcript">
            <h2>Readable card record</h2>
            <h3>{card.title}</h3>
            <p>
              Current public source facts. The earning time and edition number below are the
              retained collection record.
            </p>
            <p>{card.subject ? card.subject.subtitle : 'Subject details are no longer public.'}</p>
            <dl>
              {publicCardFacts(card.subject_type, card.subject?.facts).map(
                ({ key: k, value: v }) => (
                  <div key={k}>
                    <dt>{k.replaceAll('_', ' ')}</dt>
                    <dd>{v}</dd>
                  </div>
                )
              )}
            </dl>
            {card.subject && <p>{card.design.story}</p>}
            <p>
              Collection status: {card.ownership_status}. Earned: {card.earned_at || 'Not recorded'}
              .{' '}
              {card.ordinal
                ? `Edition number ${card.ordinal}${card.rules.cap ? ` of ${card.rules.cap}` : ''}.`
                : card.issuance_id
                  ? 'Unnumbered edition.'
                  : 'Unnumbered base collectible.'}
            </p>
            <p>Issuer: {card.issuer}</p>
          </section>
        </>
      )}
    </main>
  );
}
